import { render, staticRenderFns } from "./SectionNewContents.vue?vue&type=template&id=7650adb4&"
import script from "./SectionNewContents.vue?vue&type=script&lang=js&"
export * from "./SectionNewContents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports